import React from 'react';
import styled from '@emotion/styled';
import Button from '@via-profit/ui-kit/Button';
import Surface from '@via-profit/ui-kit/Surface';
import { useTheme } from '@via-profit/ui-kit/ThemeProvider';

import type { GeocodeResult } from '../../api/types';

export interface AddressCardProps {
  readonly result: GeocodeResult;
  /** Можно ли оставить отзыв о результате поиска (есть logId). */
  readonly canGiveFeedback: boolean;
  /** Что пользователь уже сообщил о результате. */
  readonly feedback: 'confirmed' | 'no_geo' | null;
  readonly onRoute: () => void;
  readonly onConfirm: () => void;
  readonly onNoGeo: () => void;
}

const Card = styled(Surface)`
  position: absolute;
  bottom: 24px;
  left: 16px;
  max-width: 420px;
  z-index: 10;
  font-size: 14px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;
  font-size: 13px;
`;

/** Карточка адреса, выбранного в поиске: маршрут и отзыв о результате. */
const AddressCard: React.FC<AddressCardProps> = ({
  result,
  canGiveFeedback,
  feedback,
  onRoute,
  onConfirm,
  onNoGeo,
}) => {
  const theme = useTheme();
  const success = theme.color.success.toString();
  const warning = theme.color.warning.toString();
  return (
    <Card className="overlay-card">
      <Content>
        <span>{result.fullAddress}</span>
        <Actions>
          {result.latitude != null && result.longitude != null && (
            <Button type="button" variant="outlined" color="primary" onClick={onRoute}>
              Маршрут
            </Button>
          )}
          {canGiveFeedback && (
            <>
              <Button
                type="button"
                variant={feedback === 'confirmed' ? 'outlined' : 'standard'}
                color={feedback === 'confirmed' ? success : 'primary'}
                onClick={onConfirm}
                disabled={feedback === 'confirmed'}
              >
                {feedback === 'confirmed' ? 'Подтверждено ✓' : 'Адрес верный ✓'}
              </Button>
              <Button
                type="button"
                variant="outlined"
                color={feedback === 'no_geo' ? success : warning}
                onClick={onNoGeo}
                disabled={feedback === 'no_geo'}
              >
                {feedback === 'no_geo' ? 'Записано: нет координат ✓' : 'Адрес верный, но нет на карте'}
              </Button>
            </>
          )}
        </Actions>
      </Content>
    </Card>
  );
};

export default AddressCard;
